(function () {
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function formatMoney(cents, currency) {
    var cur = currency || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: cur
      }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2) + ' ' + cur;
    }
  }

  function esc(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function getDrawerRoot() {
    return qs('[data-yc-cart-drawer-root]');
  }

  function openCartDrawer() {
    var root = getDrawerRoot();
    if (!root) return;
    root.hidden = false;
    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    var closeBtn = qs('[data-yc-cart-drawer-close]', root);
    if (closeBtn) closeBtn.focus();
  }

  function closeCartDrawer() {
    var root = getDrawerRoot();
    if (!root) return;
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!root.classList.contains('is-open')) root.hidden = true;
    }, 320);
  }

  function updateHeaderCount(count) {
    qsa('[data-yc-cart-count]').forEach(function (el) {
      el.textContent = String(count);
    });
    qsa('[data-yc-cart-count-wrap]').forEach(function (wrap) {
      wrap.hidden = !count || count <= 0;
    });
  }

  function renderRewards(cart, root) {
    var box = qs('[data-yc-cart-rewards]', root);
    if (!box) return;
    var min = parseInt(root.getAttribute('data-free-shipping-min') || '0', 10) || 0;
    var unlocked = root.getAttribute('data-msg-unlocked') || '';
    var moreTpl = root.getAttribute('data-msg-more') || '';
    var total = cart.total_price || 0;
    var msg;
    if (min <= 0) {
      msg = '🎉 ' + esc(unlocked);
    } else if (total >= min) {
      msg = '🎉 ' + esc(unlocked);
    } else {
      var remain = Math.max(0, min - total);
      msg = esc(moreTpl.replace('{amount}', formatMoney(remain, cart.currency)));
    }
    var pct = min <= 0 ? 100 : Math.min(100, Math.round((total / min) * 100));
    box.hidden = false;
    box.innerHTML =
      '<div class="yc-cart-drawer__rewards-inner">' +
      '<p class="yc-cart-drawer__rewards-msg">' +
      msg +
      '</p>' +
      '<div class="yc-cart-drawer__rewards-track"><div class="yc-cart-drawer__rewards-bar" style="width:' +
      pct +
      '%"></div></div>' +
      '<div class="yc-cart-drawer__rewards-foot"><span class="material-symbols-rounded" aria-hidden="true">local_shipping</span><span>Free Shipping</span></div></div>';
  }

  function bindLineHandlers(root) {
    var msgLine = root.getAttribute('data-msg-line-error') || 'Error';

    qsa('[data-yc-line-remove]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-yc-line-remove');
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function (r) {
            if (!r.ok) throw new Error();
            return r.json();
          })
          .then(function (c) {
            updateCartUI(c, root);
          })
          .catch(function () {
            alert(msgLine);
          });
      });
    });

    qsa('[data-yc-qty-change]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-yc-qty-change');
        var delta = parseInt(btn.getAttribute('data-delta'), 10) || 0;
        var row = btn.closest('.yc-cart-drawer__line');
        var valEl = row ? row.querySelector('.yc-cart-drawer__qty-val') : null;
        var current = valEl ? parseInt(valEl.textContent, 10) || 0 : 0;
        var qty = Math.max(0, current + delta);
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        })
          .then(function (r) {
            if (!r.ok) throw new Error();
            return r.json();
          })
          .then(function (c) {
            updateCartUI(c, root);
          })
          .catch(function () {
            alert(msgLine);
          });
      });
    });
  }

  function renderLineItems(cart, root) {
    var wrap = qs('[data-yc-cart-drawer-items]', root);
    if (!wrap) return;
    var emptyMsg = root.getAttribute('data-msg-empty') || 'Empty';
    if (!cart.items || !cart.items.length) {
      wrap.innerHTML = '<p class="yc-cart-drawer__empty">' + esc(emptyMsg) + '</p>';
      return;
    }
    var html = cart.items
      .map(function (item) {
        var img = item.image
          ? '<img src="' + esc(item.image) + '" alt="" width="88" height="88" loading="lazy" class="yc-cart-drawer__thumb-img">'
          : '';
        var cmp =
          item.original_line_price && item.original_line_price > item.final_line_price
            ? '<span class="yc-cart-drawer__compare">' + formatMoney(item.original_line_price, cart.currency) + '</span>'
            : '';
        return (
          '<div class="yc-cart-drawer__line" data-key="' +
          esc(item.key) +
          '">' +
          '<div class="yc-cart-drawer__line-img"><a href="' +
          esc(item.url) +
          '">' +
          img +
          '</a></div>' +
          '<div class="yc-cart-drawer__line-main">' +
          '<button type="button" class="yc-cart-drawer__remove" data-yc-line-remove="' +
          esc(item.key) +
          '" aria-label="' +
          esc(root.getAttribute('data-msg-remove') || 'Remove') +
          '"><span class="material-symbols-rounded" aria-hidden="true">delete</span></button>' +
          '<a class="yc-cart-drawer__line-title" href="' +
          esc(item.url) +
          '">' +
          esc(item.product_title) +
          '</a>' +
          (item.variant_title && item.variant_title !== 'Default Title'
            ? '<div class="yc-cart-drawer__variant">' + esc(item.variant_title) + '</div>'
            : '') +
          '<div class="yc-cart-drawer__line-price-row">' +
          '<span class="yc-cart-drawer__price">' +
          formatMoney(item.final_line_price, cart.currency) +
          '</span>' +
          cmp +
          '</div>' +
          '<div class="yc-cart-drawer__qty">' +
          '<button type="button" data-yc-qty-change="' +
          esc(item.key) +
          '" data-delta="-1" aria-label="Decrease">−</button>' +
          '<span class="yc-cart-drawer__qty-val">' +
          item.quantity +
          '</span>' +
          '<button type="button" data-yc-qty-change="' +
          esc(item.key) +
          '" data-delta="1" aria-label="Increase">+</button>' +
          '</div></div></div>'
        );
      })
      .join('');
    wrap.innerHTML = html;
  }

  function updateCartUI(cart, root) {
    if (!root) root = getDrawerRoot();
    if (!root) return;
    renderRewards(cart, root);
    renderLineItems(cart, root);
    bindLineHandlers(root);
    updateHeaderCount(cart.item_count || 0);
    var totalEl = qs('[data-yc-cart-checkout-total]', root);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price, cart.currency);
    var checkout = qs('[data-yc-cart-checkout]', root);
    if (checkout) checkout.hidden = !(cart.item_count > 0);
  }

  function refreshCartDrawer() {
    var root = getDrawerRoot();
    if (!root) return Promise.resolve();
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateCartUI(cart, root);
        return cart;
      });
  }

  function initCartDrawer() {
    var root = getDrawerRoot();
    if (!root) return;

    qsa('[data-yc-cart-drawer-close]', root).forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeCartDrawer();
      });
    });

    var overlay = qs('.yc-cart-drawer-overlay', root);
    if (overlay) {
      overlay.addEventListener('click', function () {
        closeCartDrawer();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) closeCartDrawer();
    });

    qsa('[data-yc-open-cart]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        refreshCartDrawer().then(function () {
          openCartDrawer();
        });
      });
    });

    var discForm = qs('[data-yc-cart-discount-form]', root);
    if (discForm) {
      discForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = discForm.querySelector('input[name="discount"]');
        var code = input && input.value ? input.value.trim() : '';
        var msgEl = qs('[data-yc-cart-discount-msg]', root);
        if (!code) return;
        fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code })
        })
          .then(function (r) {
            return r.json().then(function (j) {
              return { ok: r.ok, j: j };
            });
          })
          .then(function (res) {
            if (!res.ok) {
              if (msgEl) {
                msgEl.hidden = false;
                msgEl.textContent = res.j.description || res.j.message || 'Invalid';
              }
              return;
            }
            if (msgEl) {
              msgEl.hidden = false;
              msgEl.textContent = '✓';
            }
            updateCartUI(res.j, root);
          })
          .catch(function () {
            if (msgEl) {
              msgEl.hidden = false;
              msgEl.textContent = 'Error';
            }
          });
      });
    }

    refreshCartDrawer();
  }

  function initProductVariants() {
    var form = document.getElementById('YoracareProductForm');
    if (!form || !window.YC_PRODUCT) return;
    var product = window.YC_PRODUCT;
    var variantInput = form.querySelector('[data-yc-variant-id]');
    var selects = form.querySelectorAll('[data-yc-option-select]');
    if (!variantInput || !selects.length) return;

    var currency = window.YC_MONEY_CURRENCY || 'USD';
    var fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: currency
    });
    var str = window.YC_STRINGS || {};

    function findVariant() {
      var selected = [];
      selects.forEach(function (sel) {
        selected.push(sel.value);
      });
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === selected[i];
        });
      });
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var v = findVariant();
        if (!v || !variantInput) return;
        variantInput.value = v.id;
        var priceEl = document.querySelector('.yc-pdp__price');
        var cmpEl = document.querySelector('.yc-pdp__compare');
        var badgeEl = document.querySelector('.yc-pdp__badge-save');
        var btn = form.querySelector('button[type="submit"]');
        if (priceEl) priceEl.textContent = fmt.format(v.price / 100);
        if (cmpEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            cmpEl.style.display = '';
            cmpEl.textContent = fmt.format(v.compare_at_price / 100);
          } else {
            cmpEl.style.display = 'none';
          }
        }
        if (badgeEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            var sav = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
            badgeEl.textContent = (str.savePrefix || 'Save') + ' ' + sav + '%';
            badgeEl.style.display = '';
          } else {
            badgeEl.style.display = 'none';
          }
        }
        if (btn) {
          btn.disabled = !v.available;
          btn.textContent = v.available ? str.addToCart || 'Add to cart' : str.soldOut || 'Sold out';
        }
        var main = document.getElementById('YcGalleryMain');
        if (main && v.featured_image && v.featured_image.src) {
          var base = v.featured_image.src.split('?')[0];
          main.src = base + '?width=1400';
          main.srcset = base + '?width=700 700w, ' + base + '?width=1400 1400w';
        }
      });
    });
  }

  function initProductFormAjax() {
    var form = document.getElementById('YoracareProductForm');
    var root = getDrawerRoot();
    if (!form || !root) return;

    var errMsg = root.getAttribute('data-msg-add-error') || 'Error';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var id = idInput ? parseInt(idInput.value, 10) : 0;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var btn = form.querySelector('button[type="submit"]');
      if (!id) {
        alert(errMsg);
        return;
      }
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error(j.description || j.message || errMsg);
            return j;
          });
        })
        .then(function () {
          return refreshCartDrawer().then(function () {
            openCartDrawer();
          });
        })
        .catch(function (err) {
          alert(err.message || errMsg);
        })
        .finally(function () {
          if (btn) btn.disabled = false;
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var toggles = qsa('[data-yc-menu-toggle]');
    var nav = qs('[data-yc-mobile-nav]');
    if (nav && toggles.length) {
      toggles.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var open = nav.hasAttribute('hidden');
          if (open) {
            nav.removeAttribute('hidden');
            document.body.style.overflow = 'hidden';
            toggles.forEach(function (b) {
              b.setAttribute('aria-expanded', 'true');
            });
          } else {
            nav.setAttribute('hidden', '');
            document.body.style.overflow = '';
            toggles.forEach(function (b) {
              b.setAttribute('aria-expanded', 'false');
            });
          }
        });
      });
      nav.addEventListener('click', function (e) {
        if (e.target === nav) {
          nav.setAttribute('hidden', '');
          document.body.style.overflow = '';
          toggles.forEach(function (b) {
            b.setAttribute('aria-expanded', 'false');
          });
        }
      });
    }

    var gallery = qs('[data-yc-product-gallery]');
    if (gallery) {
      var mainImg = qs('[data-yc-gallery-main]', gallery);
      qsa('[data-yc-gallery-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var url = thumb.getAttribute('data-full-src');
          var srcset = thumb.getAttribute('data-full-srcset');
          if (mainImg && url) {
            mainImg.src = url;
            if (srcset) mainImg.setAttribute('srcset', srcset);
            else mainImg.removeAttribute('srcset');
          }
          qsa('[data-yc-gallery-thumb]', gallery).forEach(function (t) {
            t.classList.remove('is-active');
          });
          thumb.classList.add('is-active');
        });
      });
    }

    qsa('[data-yc-testimonials-root]').forEach(function (troot) {
      var vp = qs('[data-yc-testimonials-viewport]', troot);
      var dots = qsa('[data-yc-testimonial-dot]', troot);
      if (!vp || dots.length === 0) return;

      function setActive(i) {
        dots.forEach(function (d, j) {
          d.classList.toggle('is-active', j === i);
        });
      }

      function slideIndex() {
        var w = vp.clientWidth || 1;
        return Math.round(vp.scrollLeft / w);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-index'), 10) || 0;
          var w = vp.clientWidth;
          vp.scrollTo({ left: i * w, behavior: 'smooth' });
          setActive(i);
        });
      });

      vp.addEventListener(
        'scroll',
        function () {
          setActive(slideIndex());
        },
        { passive: true }
      );
    });

    initCartDrawer();
    initProductVariants();
    initProductFormAjax();
  });
})();
